module.exports = __webpack_public_path__ + "static/img/1_1_6.b1aafc75.jpg";